// Actions related to bootstrap accordions.
import { map } from 'lodash';
import SmoothScroll from 'smooth-scroll';

const accordion = ($) => {
  /* global document */
  const allToggles = document.querySelectorAll('.accordion-action-all');
  if (allToggles) {
    map(allToggles, (toggle) => {
      const button = toggle.querySelector('button');
      const $container = $(toggle).closest('.paragraph--type-accordion');
      const $items = $('.collapse', $container);
      const showAll = () => map($items, item => $(item).collapse('show'));
      const hideAll = () => map($items, item => $(item).collapse('hide'));
      $(button).on('click touch', showAll);
      $items.on('hidden.bs.collapse', () => {
        if (button.innerHTML !== 'Expand All') {
          button.innerHTML = 'Expand All';
          $(button).off('click touch').on('click touch', showAll);
        }
      });
      $items.on('shown.bs.collapse', () => {
        if ($container.find('.collapse:not(.in)').length === 0) {
          button.innerHTML = 'Collapse All';
          $(button).off('click touch').on('click touch', hideAll);
        }
      });
    });
  }
  // Handle hash links to accordion items
  setTimeout(() => {
    document.addEventListener('scrollStop', (evt) => {
      const { anchor } = evt.detail;
      if ($(anchor).hasClass('panel')) {
        $(anchor).find('.collapse').collapse('show');
      }
    }, false);
    const offset = () => {
      if (document.body.style['padding-top']) {
        return parseInt(document.body.style['padding-top'], 10);
      }
      return 0;
    };
    if (document.querySelector('[data-deferred-id]')) {
      const deferred = document.querySelectorAll('[data-deferred-id]');
      map(deferred, (el) => {
        const id = el.getAttribute('data-deferred-id');
        el.setAttribute('id', id);
      });
    }
    /* global window */
    if (window.location.hash) {
      const hash = window.location.hash.replace('#', '');
      if (document.querySelector(`[data-deferred-id="${hash}"]`)) {
        const scrollTo = document.querySelector(`[data-deferred-id="${hash}"]`);
        const scroll = new SmoothScroll();
        scroll.animateScroll(scrollTo, null, { offset, speed: 600 });
      }
    }
    /* eslint-disable no-new */
    new SmoothScroll('a[href*="#"]', { offset, speed: 600 });
  }, 100);
};

export default accordion;
